module.exports = __webpack_public_path__ + "static/media/scoreplay.c4556a09.png";